import React, { useCallback, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { ChevronRight } from '@material-ui/icons';
import { observer } from 'mobx-react';

import styles from '../css/Archives.module.css';
import AnchorStore from '../../../store/AnchorStore';
import { NAKED_NEWS_LIVE_ID } from '../../../constants/Constants';
import ArchiveStore from '../../../store/ArchiveStore';


function AnchorFilters({ collapsing, clearFilter }) {
  const { anchors, allAnchors } = AnchorStore;
  const { selectedFilter, searchFilterString } = ArchiveStore;
  const [hoveredOption, setHoveredOption] = useState(null);

  const onHover = useCallback((value) => {
    setHoveredOption(value);
  }, []);

  const sortedCurrentAnchorsList = useMemo(() => anchors?.currentAnchors?.filter((anchor, index) => anchors.currentAnchors.lastIndexOf(anchor) === index).
    sort((a, b) => a.name < b.name ? -1 : 1), [anchors]);

  const sortedGuestAnchorsList = useMemo(() => anchors?.guestAnchors?.filter((anchor, index) => anchors.guestAnchors.lastIndexOf(anchor) === index).
    sort((a, b) => a.name < b.name ? -1 : 1), [anchors]);

  const sortedPastAnchorsList = useMemo(() => anchors?.pastAnchors?.filter((anchor, index) => anchors.pastAnchors.lastIndexOf(anchor) === index).
    sort((a, b) => a.name < b.name ? -1 : 1), [anchors]);

  const getAnchorListByStatus = useCallback((anchorStatus) => {
    if (anchorStatus === 'past') {
      return sortedPastAnchorsList;
    }
    if (anchorStatus === 'guest') {
      return sortedGuestAnchorsList;
    }

    return sortedCurrentAnchorsList;
  }, [sortedCurrentAnchorsList, sortedGuestAnchorsList, sortedPastAnchorsList]);

  const getAnchorList = useCallback((anchorStatus) => {
    if (selectedFilter === 'anchor' && searchFilterString?.length > 0) {
      return allAnchors.filter((anchor) => anchor.name.toLowerCase().includes(searchFilterString.toLowerCase()));
    }

    return getAnchorListByStatus(anchorStatus);
  }, [allAnchors, getAnchorListByStatus, searchFilterString, selectedFilter]);

  const renderAnchorList = useCallback((anchorStatus) => getAnchorList(anchorStatus).map((anchor) => {
    if (anchor?.id === NAKED_NEWS_LIVE_ID) {
      return null;
    }

    return (
      <li key={anchor.id}>
        <Link key={anchor.id} className={styles.link} to={`/archives?anchorid=${anchor.id}`} onClick={clearFilter}>{anchor.name}</Link>
      </li>
    );
  }), [getAnchorList]);

  return (
    <div className={classnames('filter-list', { 'collapse': !collapsing.anchor })} id="filter-anchors">
      <ul className={styles.list}>
        <li onMouseEnter={() => onHover('current')}>Current <ChevronRight /></li>
        <li onMouseEnter={() => onHover('guest')}>Guest <ChevronRight /></li>
        <li onMouseEnter={() => onHover('past')}>Past <ChevronRight /></li>
      </ul>
      <div className={styles.menuItems}>
        <ul className={styles.list}>
          {renderAnchorList(hoveredOption)}
        </ul>
      </div>
    </div>
  );
}

export default observer(AnchorFilters);
